<div class="container-fluid min-vh-100 d-flex align-items-center justify-content-center p-3">
    <div class="row justify-content-center w-100">
        <div class="col-12 col-sm-10 col-md-8 col-lg-6 col-xl-5">
            <div class="text-center mb-4">
                <img src="/assets/images/logo-2.png" alt="Logo" class="img-fluid mb-4 logo-img">
            </div>
            <div class="card shadow-lg">
                <div class="card-body p-3 p-md-5">
                    <div class="text-center mb-4">
                        <h2 class="fw-bold text-primary fs-3 fs-md-2">
                            <i class="fa-solid fa-key me-2"></i>
                            Réinitialiser le mot de passe
                        </h2>
                        <p class="text-muted mb-0">
                            Entrez votre nouveau mot de passe
                        </p>
                    </div>

                    <form [formGroup]="resetPasswordForm" (ngSubmit)="onSubmit()">
                        <div class="form-group mb-4">
                            <label for="password" class="form-label">
                                <i class="fa-solid fa-lock text-primary me-2"></i>
                                Nouveau mot de passe
                            </label>
                            <div class="position-relative">
                                <input [type]="showPassword ? 'text' : 'password'" class="form-control pe-5"
                                    id="password" formControlName="password"
                                    placeholder="Entrez votre nouveau mot de passe"
                                    [class.is-invalid]="resetPasswordForm.get('password')?.touched && resetPasswordForm.get('password')?.invalid">
                                <button type="button"
                                    class="btn btn-link position-absolute end-0 top-50 translate-middle-y text-muted"
                                    (click)="togglePasswordVisibility()" style="z-index: 10; text-decoration: none;">
                                    <i [class]="showPassword ? 'fa-solid fa-eye-slash' : 'fa-solid fa-eye'"></i>
                                </button>
                            </div>

                            <div class="invalid-feedback"
                                *ngIf="resetPasswordForm.get('password')?.touched && resetPasswordForm.get('password')?.invalid">
                                <span *ngIf="resetPasswordForm.get('password')?.errors?.['required']">
                                    Le mot de passe est requis
                                </span>
                                <span *ngIf="resetPasswordForm.get('password')?.errors?.['minlength']">
                                    Le mot de passe doit contenir au moins 6 caractères
                                </span>
                            </div>
                        </div>

                        <div class="form-group mb-4">
                            <label for="confirmPassword" class="form-label">
                                <i class="fa-solid fa-lock text-primary me-2"></i>
                                Confirmer le mot de passe
                            </label>
                            <div class="position-relative">
                                <input [type]="showConfirmPassword ? 'text' : 'password'" class="form-control pe-5"
                                    id="confirmPassword" formControlName="confirmPassword"
                                    placeholder="Confirmez votre nouveau mot de passe"
                                    [class.is-invalid]="resetPasswordForm.get('confirmPassword')?.touched && resetPasswordForm.get('confirmPassword')?.invalid">
                                <button type="button"
                                    class="btn btn-link position-absolute end-0 top-50 translate-middle-y text-muted"
                                    (click)="toggleConfirmPasswordVisibility()"
                                    style="z-index: 10; text-decoration: none;">
                                    <i [class]="showConfirmPassword ? 'fa-solid fa-eye-slash' : 'fa-solid fa-eye'"></i>
                                </button>
                            </div>

                            <div class="invalid-feedback"
                                *ngIf="resetPasswordForm.get('confirmPassword')?.touched && resetPasswordForm.get('confirmPassword')?.invalid">
                                <span *ngIf="resetPasswordForm.get('confirmPassword')?.errors?.['required']">
                                    La confirmation du mot de passe est requise
                                </span>
                                <span *ngIf="resetPasswordForm.errors?.['passwordMismatch']">
                                    Les mots de passe ne correspondent pas
                                </span>
                            </div>
                        </div>

                        <div class="d-grid gap-2">
                            <button type="submit" class="btn btn-primary btn-lg"
                                [disabled]="resetPasswordForm.invalid || isLoading">
                                <span *ngIf="isLoading" class="spinner-border spinner-border-sm me-2" role="status"
                                    aria-hidden="true"></span>
                                Réinitialiser le mot de passe
                            </button>
                        </div>

                        <div class="text-center mt-4">
                            <a routerLink="/auth/login" class="text-decoration-none">
                                <i class="fa-solid fa-arrow-left me-2"></i>
                                Retour à la connexion
                            </a>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>

<style>
    .card {
        border: none;
        border-radius: 15px;
    }

    .form-control {
        border-radius: 10px;
        padding: 12px;
        border: 1px solid #e0e0e0;
    }

    .form-control:focus {
        box-shadow: 0 0 0 0.2rem rgba(3, 137, 201, 0.25);
        border-color: #0389C9;
    }

    .btn-primary {
        background-color: #0389C9;
        border-color: #0389C9;
        border-radius: 10px;
        padding: 12px;
        font-weight: 500;
    }

    .btn-primary:hover {
        background-color: #0277b3;
        border-color: #0277b3;
    }

    .btn-primary:disabled {
        background-color: #0389C9;
        border-color: #0389C9;
        opacity: 0.7;
    }

    .text-primary {
        color: #0389C9 !important;
    }

    .container-fluid {
        background-color: #f8f9fa;
    }

    .logo-img {
        max-width: 200px;
        height: auto;
    }

    /* Media Queries */
    @media (max-width: 768px) {
        .card-body {
            padding: 1.5rem !important;
        }

        .logo-img {
            max-width: 150px;
        }

        h2 {
            font-size: 1.5rem !important;
        }

        .form-control {
            padding: 10px;
        }

        .btn-lg {
            padding: 10px;
            font-size: 1rem;
        }
    }

    @media (max-width: 576px) {
        .container-fluid {
            padding: 1rem !important;
        }

        .card-body {
            padding: 1rem !important;
        }

        .logo-img {
            max-width: 120px;
        }

        h2 {
            font-size: 1.25rem !important;
        }

        .form-label {
            font-size: 0.9rem;
        }

        .form-control {
            font-size: 0.9rem;
        }

        .btn-lg {
            font-size: 0.9rem;
        }
    }
</style>

<app-confirm-modal [isOpen]="isModalOpen" title="Réinitialisation réussie"
    message="Votre mot de passe a été réinitialisé avec succès. Vous allez être redirigé vers la page de connexion."
    confirmText="OK" (confirm)="redirect()" (close)="redirect()">
</app-confirm-modal>